module.exports = __webpack_public_path__ + "img/logo.d7f80125.png";